import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';

import Checkbox from '@components/common/checkbox/main';
import SectionsContext from '../sectionsContext';
import TagsFilter from './tagsFilter';
import FiletypesFilter from './filetypesFilter';
import CustomfieldsFilter from './customfieldsFilter';
import OrientationFilter from './orientationFilter';
import CommentsFilter from './commentsFilter';
import SkuFilter from './skuFilter';
import DateFilter from './dateFilter';

import './styles/main';

class AdvancedFiltersDrawer extends React.PureComponent {
  render() {
    const {
      filters,
      filtersDrawerOpen,
      searchableThings,
      selectedAssetKeys,
      toggleFiltersDrawer,
      updateFilters,
      refresh,
    } = this.props;

    return (
      <SectionsContext.Consumer>
        {({ editable }) => (
          filtersDrawerOpen === "advanced-filters" ? (
            <div className={`container ${selectedAssetKeys.size ? 'select-bar-active' : ''}`}>
              <form className="search-filter-form">
                <div className="filter-section title">
                  <div className="flex-row">
                    <h3 className="filter-title">{t('Advanced Filters')}</h3>
                    <div>
                      <button
                        className="refresh-button bff-refresh"
                        onClick={refresh}
                        type="button"
                      />
                      <button
                        className="clear-button"
                        onClick={() => updateFilters("reset")}
                        type="button"
                      >
                        <span>{t('Reset')}</span>
                      </button>
                      <button
                        className="close-button"
                        onClick={() => toggleFiltersDrawer('advanced-filters')}
                        type="button"
                      >
                        <span className="bff-close" aria-hidden="true" />
                      </button>
                    </div>
                  </div>
                </div>
                <div className="filter-section strict-search cx-filters-strict">
                  <Checkbox
                    size="sm"
                    checked={filters.strict}
                    toggle={() => updateFilters("strict", true)}
                    label={t("Search exact terms")}
                  />
                </div>
                {editable ? (
                  <div className="filter-section status cx-filters-status">
                    <div className="flex-row title">
                      <span>{t('Asset Status')}</span>
                    </div>
                    <div className="approvals-section">
                      <Select
                        name="select-availability"
                        className="filter-dropdown"
                        value={filters.availability}
                        options={[
                          { value: null, label: "Select" },
                          { value: "approved", label: "Approved" },
                          { value: "unapproved", label: "Unapproved" },
                          { value: "unpublished", label: "Draft" },
                          { value: "expired", label: "Expired" }
                        ]}
                        clearable={false}
                        searchable={false}
                        placeholder={t("Select status")}
                        onChange={(option) => updateFilters("availability", option.value)}
                      />
                    </div>
                  </div>
                ) : ""}
                <TagsFilter
                  searchableThings={searchableThings}
                  tags={filters.tags}
                  updateFilters={(value) => updateFilters("tags", value)}
                />
                <FiletypesFilter
                  filetypes={filters.filetypes}
                  searchableThings={searchableThings}
                  updateFilters={(value) => updateFilters("filetypes", value)}
                />
                <CustomfieldsFilter
                  customFields={filters.custom_fields}
                  removeFilters={(key, value) => updateFilters("remove_custom_field", key, value)}
                  searchableThings={searchableThings}
                  updateFilters={(key, value) => updateFilters("custom_fields", key, value)}
                />
                <OrientationFilter
                  orientation={filters.orientation}
                  updateFilters={(value) => updateFilters("orientation", value)}
                />
                {BFG.context.hasFeature("comments") && editable ? (
                  <CommentsFilter
                    updateFilters={(value) => updateFilters("comments", value)}
                    checked={Boolean(filters.comments)}
                  />
                ) : ""
                }
                <SkuFilter updateFilters={(value) => updateFilters("sku", value)} />
                <DateFilter
                  createdDate={filters.created_at}
                  updateFilters={(value) => updateFilters("created_at", value)}
                />
              </form>
            </div>
          ) : null
        )}
      </SectionsContext.Consumer>
    );
  }
}

AdvancedFiltersDrawer.propTypes = {
  filters: PropTypes.shape({}).isRequired,
  filtersDrawerOpen: PropTypes.oneOf(['labels', 'advanced-filters', 'none']).isRequired,
  searchableThings: PropTypes.shape({}).isRequired,
  selectedAssetKeys: PropTypes.instanceOf(Set).isRequired,
  toggleFiltersDrawer: PropTypes.func.isRequired,
  updateFilters: PropTypes.func.isRequired,
  refresh: PropTypes.func,
};

AdvancedFiltersDrawer.defaultProps = {
  refresh: () => {},
};

export default AdvancedFiltersDrawer;
